import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=55db0980&scoped=true&"
import script from "./termsAndConditions.vue?vue&type=script&lang=js&"
export * from "./termsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./termsAndConditions.vue?vue&type=style&index=0&id=55db0980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db0980",
  null
  
)

export default component.exports